export const formatDuration = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return `${rest} min`;
  return rest ? `${hours}h ${rest} min` : `${hours}h`;
};

const DURATION_STEP_MINUTES = 15;
const DURATION_MAX_MINUTES = 240;

const BASE_DURATION_OPTIONS = Array.from(
  { length: DURATION_MAX_MINUTES / DURATION_STEP_MINUTES },
  (_, index) => {
    const minutes = (index + 1) * DURATION_STEP_MINUTES;
    return { key: String(minutes), label: formatDuration(minutes) };
  },
);

// Keeps a saved duration that is not on the 15-minute grid selectable
export const getDurationOptions = (current?: number) => {
  if (!current || BASE_DURATION_OPTIONS.some((option) => option.key === String(current))) {
    return BASE_DURATION_OPTIONS;
  }
  return [...BASE_DURATION_OPTIONS, { key: String(current), label: formatDuration(current) }].sort(
    (a, b) => Number(a.key) - Number(b.key),
  );
};
